import { PaymentMethodsEnum } from '../../../../../views/phone-answering/constants';

export default {
  options: {
    [PaymentMethodsEnum.Cash]: 'Käteinen',
    [PaymentMethodsEnum.Online]: 'Verkossa',
    [PaymentMethodsEnum.InStoreCard]: 'Kortti paikan päällä',
  },
};
